import React, { useState } from 'react'

import usePostData from 'hooks/post-data'

import { TableComponent } from 'components/common/table-components'
import { ActionButton, MinimalButtonGroup } from 'components/common/buttons'
import { PopupModal } from 'components/common/others'
import { MinimalAutoComplete, MinimalInput } from 'components/Assets/components'

import EditOutlinedIcon from '@material-ui/icons/EditOutlined'

import { fedByTypeOptions, racewayTypesOptions, conductorTypesOptions, conductorSizeOptions, fedByTypeOptionsName, connectionType, materialNonFlexType } from 'components/WorkOrders/onboarding/utils'
import { isEmpty, get, filter } from 'lodash'

import asset from 'Services/assets'
import getUserRole from 'helpers/getUserRole'
import enums from 'Constants/enums'

const FedByCircuits = ({ initialLoading, data, reFetch, assetDetails, allDropDownData = [] }) => {
  const [type, setType] = useState(1)
  const [viaSubComponent, setViaSubComponent] = useState(null)
  // const [length, setLength] = useState('')
  const [style, setStyle] = useState('')
  const [anchorObj, setAnchorObj] = useState({})
  const [opened, setOpened] = useState(false)
  const fedByOpts = fedByTypeOptions.map(d => ({ ...d, label: d.value === 1 ? 'Normal' : 'Emergency' }))
  const [conductorType, setConductorType] = useState([])
  const [racewayType, setRacewayType] = useState([])
  const [conductorNumber, setConductorNumber] = useState('')
  const [opcMainOptions, setOcpMainOptions] = useState([])
  const [ocpMain, setOcpMain] = useState(null)

  // new flow
  const [conductorJson, setConductorJson] = useState([])
  const [topLevelAsset, setTopLevelAsset] = useState([])
  const [subLevelAsset, setSubLevelAsset] = useState([])
  const [LineSideOcp, setLineSideOcp] = useState([])
  const [connectionTypeName, setConnectionTypeName] = useState()
  const [connectType, setConnectType] = useState()
  const [material, setMaterial] = useState()
  const [diaMeter, setDiaMeter] = useState(0)
  const [length, setLength] = useState(0)
  const [sets, setSets] = useState(0)

  //
  const checkUserRole = new getUserRole()
  const columns = [
    { name: 'Asset', accessor: 'parentAssetName', isHidden: false },
    { name: 'Asset Class', accessor: 'parentAssetClassName', isHidden: false },
    { name: 'Load Side OCP', accessor: 'fedByViaSubcomponentAssetName', isHidden: false },
    { name: 'Line Side OCP Main', accessor: 'viaSubcomponentAssetName', isHidden: false },
    {
      name: 'Connection Type',
      render: d => {
        const td = fedByOpts.find(q => q.value === d.fedByUsageTypeId)
        if (isEmpty(td)) return 'NA'
        return td.label
      },
      isHidden: false,
    },
    {
      name: 'Action',
      render: d => (
        <div className='d-flex align-items-center'>
          <ActionButton tooltip='EDIT CIRCUIT' action={e => handleAction(e, d, 'EDIT')} icon={<EditOutlinedIcon fontSize='small' />} />
        </div>
      ),
      isHidden: false,
    },
  ]
  const handleAction = async (e, d, type) => {
    if (type === 'VIEW') return window.open(`../details/${d.parentAssetId}`, '_blank')
    e.stopPropagation()
    setAnchorObj(d)
    setTopLevelAsset(d.parentAssetName)
    const lineOcp = get(assetDetails, 'asset_subcomponents_mapping_list', []).find(sub => sub.line_load_side_id === enums.SUB_COMPONENT_TYPE.LINE_SIDE)
    setLineSideOcp(lineOcp)
    if (!isEmpty(d.fedbyDetailsJson)) {
      const fedJson = JSON.parse(d.fedbyDetailsJson)
      const conductorSize = Array.isArray(fedJson.conductors)
        ? fedJson.conductors.map((d, index) => ({
            ...d,
            id: index,
            size: get(allDropDownData, `${enums.DROPDOWN_OPTIONS.CONDUCTOR_SIZE}`, conductorSizeOptions).find(val => val.value === d.size) || get(allDropDownData, `${enums.DROPDOWN_OPTIONS.CONDUCTOR_SIZE}`, conductorSizeOptions)[0],
          }))
        : []
      setConductorJson(conductorSize)
      setDiaMeter(Math.max(get(fedJson, 'diameter', 0), 0))
      setLength(Math.max(get(fedJson, 'length', 0), 0))
      setSets(Math.max(get(fedJson, 'sets', 0), 0))
      setConnectType(connectionType.find(conn => conn.label === fedJson.type)?.value)
      setConnectionTypeName(fedByTypeOptionsName.find(fed => fed.value === d.fedByUsageTypeId)?.value)
      setMaterial(materialNonFlexType.find(mt => mt.label === fedJson.material)?.value)
    }

    if (type === 'EDIT') {
      const ocpMain = await asset.subComponents.get({ assetId: d.parentAssetId, pageindex: 0, pagesize: 0 })
      if (ocpMain.success > 0) {
        const ocpOptions = get(ocpMain, 'data.list', []).map(v => ({ ...v, label: v.sublevelcomponentAssetName, value: v.sublevelcomponentAssetId }))
        setOcpMainOptions(ocpOptions)
        const ocpMainselect = ocpOptions.find(q => q.value === d.fedByViaSubcomponantAssetId)
        !isEmpty(ocpMainselect) ? setSubLevelAsset(ocpMainselect) : setOcpMain(null)
      }
      setOpened(true)
    }
  }
  //
  const postError = () => setOpened(false)
  const postSuccess = () => {
    setOpened(false)
    reFetch()
  }
  const { loading: updateLoading, mutate: updateFedBy } = usePostData({ executer: asset.circuit.updateFedByCircuit_V2, postError, postSuccess, message: { success: 'LineSide Connection updated !', error: 'Something went wrong' } })
  const update = async () => {
    const fedJson = {
      type: connectionType.find(d => d.value === connectType)?.label,
      material: connectType === 3 || connectType === 4 ? '' : materialNonFlexType.find(d => d.value === material)?.label,
      diameter: diaMeter,
      length: length,
      sets: sets,
      conductors: conductorJson.map(d => ({
        amount: d.amount,
        material: d.material,
        size: d.size.value,
      })),
    }
    const conductorLabels = fedJson?.conductors
      ?.map(conductor => {
        if (!conductor.amount || !conductor.size || !conductor.material) return null
        const materialLabel = conductor.material === 'Copper' ? 'Cu' : 'Al'
        return `${conductor.amount}x ${materialLabel} ${conductor.size}`
      })
      .filter(Boolean)
      .join(', ')
    const details = [fedJson?.sets ? `${fedJson.sets} Parallel Sets` : null, fedJson?.diameter ? `${fedJson.diameter}"` : null, fedJson?.material ? fedJson.material : null, fedJson?.length ? `${fedJson.length}'` : null, conductorLabels ? conductorLabels : null].filter(Boolean).join(' ')

    fedJson['label'] = details

    updateFedBy({
      assetParentHierrachyId: anchorObj.assetParentHierrachyId,
      parentAssetId: anchorObj.parentAssetId,
      viaSubcomponentAssetName: get(LineSideOcp, 'sublevelcomponent_asset_name', ''),
      viaSubcomponantAssetClassCode: get(LineSideOcp, 'asset_class_code', ''),
      viaSubcomponentAssetId: get(LineSideOcp, 'sublevelcomponent_asset_id', null),
      fedByViaSubcomponantAssetId: get(subLevelAsset, 'value', null),
      fedByUsageTypeId: connectionTypeName ? fedByTypeOptionsName.find(fed => fed.value === connectionTypeName)?.value : null,
      fedbyDetailsJson: JSON.stringify(fedJson),
    })
  }

  console.log(LineSideOcp)
  const handleAddConductorType = () => {
    setConductorJson(prev => [...prev, { amount: 1, material: 'Copper', size: get(allDropDownData, `${enums.DROPDOWN_OPTIONS.CONDUCTOR_SIZE}`, conductorSizeOptions)[0], id: prev.length }])
  }

  const handleInputConductor = (id, key, value) => {
    const updatedConductor = [...conductorJson]
    const currentConductor = updatedConductor.find(d => d.id === id)
    if (key === 'increment') {
      currentConductor['amount'] = Number(currentConductor['amount']) + 1
    } else if (key === 'decrement') {
      currentConductor['amount'] = Math.max(Number(currentConductor['amount']) - 1, 1)
    } else {
      currentConductor[key] = value
    }
    setConductorJson(updatedConductor)
  }
  const handleCloseFedBy = () => {
    setOpened(false)
    setTopLevelAsset([])
    setSubLevelAsset([])
    setRacewayType([])
    setConductorType([])
    setConductorJson([])
    setDiaMeter(0)
    setLength(0)
    setSets(0)
    setConnectType()
    setConnectionTypeName()
    setMaterial()
  }
  return (
    <div className='table-responsive dashboardtblScroll' id='style-1' style={{ height: '140px' }}>
      <TableComponent loading={initialLoading} columns={columns.filter(e => e.isHidden === false)} data={data} onRowClick={d => handleAction({}, d, 'VIEW')} isForViewAction={true} />
      {opened && (
        <PopupModal width='750px' open={opened} onClose={handleCloseFedBy} title='Line-Side Connection' handleSubmit={update} cta='Update' isFixed tblResponsive loadingText='Updating...'>
          <div className='text-bold'>FED-BY</div>
          <div className='d-flex justify-content-between align-items-center'>
            <div>Fed-by Asset</div>
            <MinimalInput value={topLevelAsset} placeholder='N/A' w={45} disabled />
          </div>
          <div className='d-flex justify-content-between align-items-center'>
            <div>Load-Side OCP</div>
            <MinimalAutoComplete options={filter(opcMainOptions, item => item.lineLoadSideId === enums.SUB_COMPONENT_TYPE.LOAD_SIDE)} value={subLevelAsset} onChange={setSubLevelAsset} placeholder='Select OCP' w={45} isClearable />
          </div>
          <div className='text-bold mt-2'>FEEDING</div>
          <div className='d-flex justify-content-between align-items-center'>
            <div>Feeding Asset</div>
            <MinimalInput value={get(assetDetails, 'name', '')} placeholder='N/A' w={45} disabled />
          </div>
          <div className='d-flex justify-content-between align-items-center'>
            <div>Line-Side OCP Main</div>
            <MinimalInput w={45} value={get(LineSideOcp, 'sublevelcomponent_asset_name', '')} placeholder='N/A' disabled />
          </div>
          <div className='text-bold mt-2'>CONNECTION DETAILS</div>
          <div className='d-flex justify-content-between align-items-center mt-2'>
            <div>Connection Type</div>
            <MinimalButtonGroup value={connectionTypeName} onChange={setConnectionTypeName} options={fedByTypeOptionsName} w={45} />
          </div>
          <div className='d-flex justify-content-between align-items-center'>
            <div>Type</div>
            <MinimalButtonGroup value={connectType} onChange={setConnectType} options={connectionType} w={76} />
          </div>
          {(connectType === 1 || connectType === 2) && (
            <div className='d-flex justify-content-between align-items-center'>
              <div>Material</div>
              {connectType === 1 && <MinimalButtonGroup value={material} onChange={setMaterial} options={filter(materialNonFlexType, obj => obj.value <= 4)} w={50} />}
              {connectType === 2 && <MinimalButtonGroup value={material} onChange={setMaterial} options={filter(materialNonFlexType, obj => obj.value >= 5)} w={50} />}
            </div>
          )}
          <div className='d-flex justify-content-between align-items-center' style={{ height: '50px' }}>
            <div>Diameter (inches)</div>
            <div className='d-flex align-items-center justify-content-between mx-2' style={{ fontSize: 15, width: '130px' }}>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setDiaMeter(Math.max(diaMeter - 0.5, 0))}>
                −
              </span>
              <span className='text-bold'>{diaMeter}</span>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setDiaMeter(diaMeter + 0.5)}>
                +
              </span>
            </div>
          </div>
          <div className='d-flex justify-content-between align-items-center' style={{ height: '50px' }}>
            <div>Length (feet)</div>
            <div className='d-flex align-items-center justify-content-between mx-2' style={{ fontSize: 15, width: '130px' }}>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setLength(Math.max(length - 5, 0))}>
                −
              </span>
              <span className='text-bold'>{length}</span>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setLength(length + 5)}>
                +
              </span>
            </div>
          </div>
          <div className='d-flex justify-content-between align-items-center' style={{ height: '50px' }}>
            <div>Parallel Sets</div>
            <div className='d-flex align-items-center justify-content-between mx-2' style={{ fontSize: 15, width: '130px' }}>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setSets(Math.max(sets - 1, 0))}>
                −
              </span>
              <span className='text-bold'>{sets}</span>
              <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => setSets(sets + 1)}>
                +
              </span>
            </div>
          </div>
          <div className='d-flex justify-content-between' style={{ position: 'relative' }}>
            <div className='text-bold mt-2'>CONDUCTORS</div>
            <div className='text-bold' style={{ position: 'absolute', right: '11px', top: '12px' }}>
              Conductor Size
            </div>
          </div>
          {conductorJson?.map(d => {
            return (
              <div className='d-flex justify-content-between align-items-center mt-2' key={d.id}>
                <div className='d-flex justify-content-between align-items-center' style={{ height: '50px' }}>
                  <div className='d-flex align-items-center justify-content-between' style={{ fontSize: 15, width: '130px' }}>
                    <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => handleInputConductor(d.id, 'decrement', '')}>
                      −
                    </span>
                    <span className='text-bold'>{get(d, 'amount', 0)}</span>
                    <span className='d-flex align-items-center justify-content-center text-bold' style={{ width: 25, height: 25, cursor: 'pointer', border: '1px solid', borderRadius: '50%' }} onClick={() => handleInputConductor(d.id, 'increment', '')}>
                      +
                    </span>
                  </div>
                </div>
                <MinimalButtonGroup value={get(d, 'material', 'Copper')} onChange={value => handleInputConductor(d.id, 'material', value)} options={conductorTypesOptions} w={30} baseStyles={{ marginTop: '10px' }} />
                <MinimalAutoComplete options={get(allDropDownData, `${enums.DROPDOWN_OPTIONS.CONDUCTOR_SIZE}`, conductorSizeOptions)} value={get(d, 'size', '18 AWG')} onChange={value => handleInputConductor(d.id, 'size', value)} w={25} />
              </div>
            )
          })}
          {conductorJson.length < 4 && (
            <div onClick={handleAddConductorType} className='p-2 m-2 text-bold' style={{ borderRadius: '4px', cursor: 'pointer', border: '1px dashed #a1a1a1', background: 'none', textAlign: 'center' }}>
              Add Conductor Type
            </div>
          )}
        </PopupModal>
      )}
    </div>
  )
}

export default FedByCircuits
